import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { ProjectDeadlineExtensionsDetail } from 'features/Project/pages/ProjectDeadlineExtensions/pages';

function ProjectDeadlineExtensionsDetailPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <ProjectDeadlineExtensionsDetail />
      </Layout>
    </LayoutProvider>
  );
}

export default ProjectDeadlineExtensionsDetailPage;
